import { useEffect, useState } from 'react';

import { GrossRevenueData } from '../../../../interfaces/entity-dashboard/GrossRevenueData';
import { entityDashboardService } from '../../../../services/entityDashboardService';
import { getDateRangeByPreset } from '../../../../../shared/utils/getDateRangeByPreset/getDateRangeByPreset';
import { DateRangePreset } from '../../../../../shared/constants/dateRangePreset';
import { SolutionTypeFilter } from '../../../../../shared/constants/user-info/solutionType';

type UseGrossRevenueDataReturn = {
  grossRevenueData: GrossRevenueData | null;
};

type UseGrossRevenueDataProps = {
  dateRangePreset: DateRangePreset;
  solutionTypeFilter: SolutionTypeFilter;
};

export const useGrossRevenueData = ({
  dateRangePreset,
  solutionTypeFilter,
}: UseGrossRevenueDataProps): UseGrossRevenueDataReturn => {
  const [grossRevenueData, setGrossRevenueData] = useState<GrossRevenueData | null>(null);

  const fetchGrossRevenueData = async () => {
    const dateRange = getDateRangeByPreset(dateRangePreset);

    const data = await entityDashboardService.getGrossRevenueData({
      ...dateRange,
      solutionType: solutionTypeFilter,
    });

    setGrossRevenueData(data);
  };

  useEffect(() => {
    fetchGrossRevenueData();
  }, [dateRangePreset, solutionTypeFilter]);

  return { grossRevenueData };
};
